export default function TableContainer({className, ...props}) {

    return (
        <div className={` ${className} overflow-auto rounded-lg bg-white dark:bg-darkTheme-800 border-[1px]  `}>
            <div className={` ${className}  whitespace-nowrap  overflow-x-auto `}>
                {
                    props.children
                }

            </div>
        </div>

    )
}